import Experience from "../Experience";
import * as THREE from 'three'

export default class SnowTree
{
    constructor()
    {
        this.experience = new Experience()
        this.scene = this.experience.scene
        this.resources = this.experience.resources
        this.debug = this.experience.debug
        
        //Setup
        this.snowTree = this.resources.items.snowTree
        this.christmasTree = this.resources.items.christmasTree


        this.setSnowTree()
        this.setChristmasTree()
        this.setDebug()
    }

    setSnowTree() {
        const treeConfigurations = [
            { position: [20, 0.2, 28], scale: 0.009 },
            { position: [30, 0.5, 28], rotationY: 0.1, scale: 0.009 },
            { position: [10, 0.7, 4], rotationY: 0.1, scale: 0.009 },
            { position: [6, 0.7, 12], rotationY: 0.1, scale: 0.01 },
            { position: [7, 0.7, 25], rotationY: 0.1, scale: 0.009 },
            { position: [48, 0.7, 12], rotationY: 0.1, scale: 0.008 },
            { position: [50, 0.7, 22], rotationY: 0.1, scale: 0.01 },
            { position: [52, 0.7, 2], rotationY: 0.2, scale: 0.007 },
            { position: [46, 1, 32], rotationY: 0.1, scale: 0.009 },
        ];
    
        this.trees = [];
    
        treeConfigurations.forEach((config) => {
            const tree = this.snowTree.scene.clone();
            tree.position.set(config.position[0], config.position[1], config.position[2]);
            if (config.rotationY) tree.rotation.y = config.rotationY;
            tree.scale.setScalar(config.scale);
            this.scene.add(tree);
    
            tree.traverse((child) => {
                if (child instanceof THREE.Mesh) {
                    child.castShadow = true;
                }
            });
    
            this.trees.push(tree);
        });
    }
    

    setChristmasTree()
    {
        this.model = this.christmasTree.scene
        this.scene.add(this.model)

        this.model.scale.setScalar(0.04)
        this.model.position.set(- 0.5, 1, -8)
        this.model.rotation.y = 0.2

        this.model.traverse((child) => {
            if (child instanceof THREE.Mesh) {
                child.castShadow = true;
                child.receiveShadow = true
            }
        });

        this.starsLight = new THREE.PointLight('#FFC145', 14, 0, 3)
        this.scene.add(this.starsLight)
        this.starsLight.position.set(-0.5, 6.35, -7.30)
    }

    setDebug()
    {
        if(this.debug.active)
        {
            this.debugTreeLight = this.debug.degugLight.addFolder('debugTreeLight')
            this.debugTreeLight.add(this.starsLight.position, 'x').min(0).max(20).step(0.0001)
            this.debugTreeLight.add(this.starsLight.position, 'y').min(-10).max(20).step(0.0001)
            this.debugTreeLight.add(this.starsLight.position, 'z').min(-10).max(20).step(0.0001)
        }
    }
}